import React from "react";
import login from "../../Assets/brand/login.svg";

const LoginIllustration: React.FC = () => {
  return (
    <div id="login-illustration-container" className="max-w-md">
      <img
        id="login-illustration-image"
        src={login}
        alt="Healthcare illustration"
        className="w-full h-auto"
      />
    </div>
  );
};

export default LoginIllustration;
